import { ReferentialsApi, Configuration as ReferentialsConfig } from 'api/referential';
import { createApiConfig } from './adapters';

export const referentialsApi = new ReferentialsApi(createApiConfig(ReferentialsConfig));
